import _ from 'lodash';
import qs from 'qs';
import Debug from '@/util/debug';
import FormInput from '@/components/form-input/FormInput.vue';
import Loading from '@/components/loading/Loading.vue';
import * as LocalStorage from '@/util/local-storage';
import { LOGIN_TYPES } from '@/services/AuthService';
import { getPrefillUrlParams } from '@/util/prefill';


const debug = Debug('login');

export default {
  dependencies: [
    'authService',
    'adApiService',
    'apiKeyService',
    'publicConfigService',
    'localeService',
  ],
  components: {
    Loading,
    'form-input': FormInput,
  },
  data() {
    return {
      email: '',
      password: '',
      loginError: null,
      autoLoginInProgress: true,
      passwordResetUrl: null,
      rememberMe: false,
      ssoLogin: false,
    };
  },
  computed: {
    jwtToken() {
      return this.$route.query.jwtToken;
    },
  },
  mounted() {
    if (this.$route.query.lang) {
      this.localeService.changeLocale(this.$route.query.lang);
    }
    let storedKey = this.apiKeyService.fromPersistance();
    // Try sso login
    if (!storedKey && this.jwtToken) {
      storedKey = this.jwtToken;
      this.authService.setCookie('login_type', LOGIN_TYPES.SSO);
    }
    const fin = () => this.autoLoginInProgress = false;

    if (storedKey && !this.apiKeyService.getKey()) {
      this.apiKeyService.setKey(storedKey);
      this.apiKeyService.toPersistance(storedKey, this.rememberMe);
      this.authService.updateUser()
        .then(fin)
        .then(() => LocalStorage.get('router:last', '/'))
        .then(value => {
          this.$router.replace(value);
        })
        .catch(err => {
          debug.warn('error while using stored key: %o', err);
          this.apiKeyService.setKey(null);
          fin();
        });
    } else {
      fin();
      this.$nextTick(() => {
        this.$refs.email.$el.querySelector('input').focus();
      });
    }

    this.publicConfigService.getConfig()
      .then(c => c.password_reset_url || '')
      .then(url => this.passwordResetUrl = url)
      .then(() => {
        const loginTypes = _.get(this.publicConfigService, 'config.agent.login_types', []);
        if (loginTypes.includes('sso')) {
          this.ssoLogin = true;
        }
      });
  },
  methods: {
    tryLogin() {
      this.error = null;
      if (!this.email && !this.password) {
        this.loginError = this.$t('pos.login.empty-credentials');
      } else {
        this.authService.login(this.email, this.password, this.rememberMe)
          .then(() => {
            debug.info('success');
            this.$router.push('/');
          })
          .catch(err => {
            debug.warn('error: %o', err);
            this.loginError = Array.isArray(err) ? err.join(' ') : err;
          });
      }
    },
    onSsoLogin() {
      const callbackPath = `${window.location.origin}${this.$router.resolve({ name: 'login' }).href}`;
      const callbackParams = getPrefillUrlParams();
      callbackParams.jwtToken = '{token}'; // will be replaced by FAM with jwt token

      const callbackUrl = `${callbackPath}?${qs.stringify(callbackParams)}`;
      const targetUrl = this.adApiService.getApiUrl(`auth/remote/login?redirectUrl=${encodeURIComponent(callbackUrl)}`);

      window.location.href = targetUrl;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/login/Login.js